import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { useDispatch, useSelector } from "react-redux";

export default function DeleteAlertDialog({
  open,
  setOpen,
  setDeleteId,
  rowId,
}) {
  const user = useSelector((state) => state.user);
  const agree = () => {
    setDeleteId(rowId);
  };

  const dispatch = useDispatch();

  const disagree = () => {
    setDeleteId(-1);
    setOpen(false);
  };

  return (
    <div>
      {/* <Button variant="outlined" onClick={handleClickOpen}>
        Open alert dialog
      </Button> */}
      <Dialog
        open={open}
        onClose={() => {
          // setOpen(false);
          // dispatch({ type: "" });
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-titletitle">Delete Row?</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            This will delete the row with id: {rowId}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={disagree} className="cancel-button">
            Cancel
          </Button>
          <Button
            disabled={/^Trial_User$/i.test(user.role) ? true : false}
            onClick={agree}
            autoFocus
            className="blue-button"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
